import { render, staticRenderFns } from "./TableSendDetail.vue?vue&type=template&id=ade3eebc&scoped=true"
import script from "./TableSendDetail.vue?vue&type=script&lang=js"
export * from "./TableSendDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade3eebc",
  null
  
)

export default component.exports